import {ColumnPropertyLazySelect} from "../types/records-table.types";

export const propertyLazySelectDataProduct: ColumnPropertyLazySelect = {
  recourseName: 'Product',
  providerType: 'DEFAULT'
}
